<template>
  <!-- Compact timestamp ("25 min", "3 w") that reveals the full stamp
       ("2026-04-22 - 15:03") on hover, or on tap on touch devices — the long
       "about 3 weeks ago" phrasing ate a whole header row next to the username. -->
  <v-tooltip :text="absolute" location="top" open-on-click>
    <template #activator="{ props: activatorProps }">
      <span
        v-bind="activatorProps"
        class="relative-time text-neutral400 text-body-2"
        v-text="label"
      />
    </template>
  </v-tooltip>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { getCompactDistance, compactDistanceKey, formatDateTimeAbsolute } from '@/utils/date-format'

const props = defineProps({
  // ISO string or Date. Null renders nothing (item not yet persisted).
  date: {
    type: [String, Date],
    default: null,
  },
})

const { t, locale } = useI18n()

const parsedDate = computed(() => (props.date ? new Date(props.date) : null))

const label = computed(() => {
  if (!parsedDate.value) return ''
  const { unit, count } = getCompactDistance(parsedDate.value)
  return t(compactDistanceKey(unit), { n: count })
})

const absolute = computed(() => {
  if (!parsedDate.value) return ''
  return formatDateTimeAbsolute(parsedDate.value, locale.value)
})
</script>

<style lang="scss" scoped>
// Signals the tooltip affordance without turning the timestamp into a link.
.relative-time {
  cursor: default;
  white-space: nowrap;
}
</style>
